// extracted by mini-css-extract-plugin
export default {"container":"a9-z","productName":"b9-z","price":"c9-z","dimensions":"d9-z"};